import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

// Import global styles and components
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import RoutesApp from './routes/index.tsx';
import './styles/fonts.css';

// Initialize Sentry for error tracking
Sentry.init({
  dsn : 'https://ebf7672fc6cb6e4ec4e9d6323b596f19@o4508138191454208.ingest.us.sentry.io/4508167928545280',
  integrations : [],
});

// Render the React application
ReactDOM.createRoot(document.getElementById('root')!).render(<RoutesApp />);
